import { render, staticRenderFns } from "./Offerzone.vue?vue&type=template&id=619b5049&scoped=true&"
import script from "./Offerzone.vue?vue&type=script&lang=js&"
export * from "./Offerzone.vue?vue&type=script&lang=js&"
import style0 from "./Offerzone.vue?vue&type=style&index=0&id=619b5049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619b5049",
  null
  
)

export default component.exports